import Vue from "vue";
import Router from "vue-router";
import Index from "@/components/Index";
import Home from "@/components/Home";
import Teacher from "@/components/Teacher";
import Student from "@/components/Student";
import Parent from "@/components/Parent";
import AppDownload from "@/components/AppDownload";
import AppTeachDownload from "@/components/AppTeachDownload";
import AppStudentDownload from "@/components/AppStudentDownload";
import Licence from "@/components/Licence";
import privates from "@/components/privates";
import race from "@/components/race";
import SignIndex from "@/components/sign/Clazz";
import SignStudent from "@/components/sign/Student";
import Sign from "@/components/sign/Sign";
import LingYongChuKu from "@/components/sign/LingYongChuKu";

import UserKnow from "@/components/UserKnow";
import Version from "@/components/Version";
import Agreement from "@/components/Agreement";

// import signUpList from '@/components/joint-assess/signUpList'
import signUpList from "@/components/joint-assess/signUpListTwo";
import signUpListPhone from "@/components/joint-assess/signUpListPhone";

import English from "@/components/advHtml/english";
import Matics from "@/components/advHtml/matics";
import SureLogin from "@/components/advHtml/surelogin";
import ForgetPassword from "@/components/ForgetPassWord";
import InitPassWord from "@/components/InitPassWord";
// import Methodtreasurepage from '../../copyRightmethodtreasurepage.html'

// 隐私政策
import StudentPrivacy from "@/components/licence/StudentPrivacy.vue";
import StudentPrivacy2 from "@/components/licence/StudentPrivacy2.vue";

import TeacherPrivacy from "@/components/licence/TeacherPrivacy.vue";
import TeacherPrivacy2 from "@/components/licence/TeacherPrivacy2.vue";

import ProductProtocol from "@/components/licence/ProductProtocol.vue";
import UseProtocol from "@/components/licence/UseProtocol.vue";
import CopyrightNotice from "@/components/licence/CopyrightNotice.vue";

import ParentCopyrightNotice from "@/components/licence/ParentCopyrightNotice.vue";
import ParentPrivacy from "@/components/licence/ParentPrivacy.vue";

import XbTeacherPrivacy from "@/components/licence/XbTeacherPrivacy.vue";
import XbProductProtocol from "@/components/licence/XbProductProtocol.vue";
import XbUseProtocol from "@/components/licence/XbUseProtocol.vue";
import XbCopyrightNotice from "@/components/licence/XbCopyrightNotice.vue";

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "Index",
      component: Index,
      children: [
        {
          path: "",
          name: "Home",
          component: Home,
        },
      ],
    },
    {
      path: "/privacy",
      name: "privates",
      component: privates,
    },
    {
      path: "/race",
      name: "race",
      component: race,
    },
    {
      path: "/index",
      name: "Index",
      component: Index,
      children: [
        {
          path: "teacher",
          name: "Teacher",
          component: Teacher,
        },
        {
          path: "student",
          name: "Student",
          component: Student,
        },
        {
          path: "parent",
          name: "Parent",
          component: Parent,
        },
      ],
    },
    {
      path: "/signUpList",
      name: "signUpList",
      component: signUpList,
    },
    {
      path: "/signUpListPhone",
      name: "signUpListPhone",
      component: signUpListPhone,
    },
    {
      path: "/app",
      name: "AppDownload",
      component: AppDownload,
    },
    // {
    //   path: '/methodtreasurepage',
    //   name: 'methodtreasurepage',
    //   component: Methodtreasurepage
    // },
    {
      path: "/teacherdownload",
      name: "AppTeachDownload",
      component: AppTeachDownload,
    },
    {
      path: "/studentdownload",
      name: "AppStudentDownload",
      component: AppStudentDownload,
    },
    {
      path: "/licence",
      name: "Licence",
      component: Licence,
    },
    {
      path: "/signclazz",
      name: "SignClazz",
      component: SignIndex,
    },
    {
      path: "/signstu",
      name: "SignStudent",
      component: SignStudent,
    },
    {
      path: "/sign",
      name: "Sign",
      component: Sign,
    },
    {
      path: "/lingyong",
      name: "LingYong",
      component: LingYongChuKu,
    },
    {
      path: "/userknow",
      name: "UserKnow",
      component: UserKnow,
    },
    {
      path: "/version",
      name: "Version",
      component: Version,
    },
    {
      path: "/agreement",
      name: "Agreement",
      component: Agreement,
    },
    {
      path: "/forgetpassword",
      name: "ForgetPassword",
      component: ForgetPassword,
    },
    {
      path: "/initPassword",
      name: "InitPassWord",
      component: InitPassWord,
    },
    // 猜题活动页
    {
      path: "/english",
      name: "english",
      component: English,
    },
    {
      path: "/matics",
      name: "matics",
      component: Matics,
    },
    {
      path: "/surelogin",
      name: "surelogin",
      component: SureLogin,
    },
    {
      path: "/bigdatalogin",
      name: "BigDataLogin",
      component: () => import("../components/BigDataLogin"),
    },
    {
      path: "/studentpricacy",
      name: "StudentPrivacy",
      component: StudentPrivacy,
      meta: {
        title: "隐私服务",
      },
    },
    {
      path: "/studentpricacy2",
      name: "StudentPrivacy2",
      component: StudentPrivacy2,
      meta: {
        title: "隐私服务及权限说明",
      },
    },
    {
      path: "/teacherpricacy",
      name: "TeacherPrivacy",
      component: TeacherPrivacy,
      meta: {
        title: "隐私服务",
      },
    },
    {
      path: "/teacherpricacy2",
      name: "TeacherPrivacy2",
      component: TeacherPrivacy2,
      meta: {
        title: "隐私服务及权限说明",
      },
    },
    {
      path: "/productprotocol",
      name: "ProductProtocol",
      component: ProductProtocol,
      meta: {
        title: "产品服务协议",
      },
    },
    {
      path: "/useprotocol",
      name: "UseProtocol",
      component: UseProtocol,
      meta: {
        title: "软件使用协议",
      },
    },
    {
      path: "/copyrightnotice",
      name: "CopyrightNotice",
      component: CopyrightNotice,
      meta: {
        title: "版权声明",
      },
    },
    {
      path: "/parentcopyright",
      name: "ParentCopyrightNotice",
      component: ParentCopyrightNotice,
      meta: {
        title: "版权声明",
      },
    },
    {
      path: "/parentpricacy",
      name: "ParentPrivacy",
      component: ParentPrivacy,
      meta: {
        title: "隐私政策",
      },
    },
    {
      path: "/xbteacherpricacy",
      name: "XbTeacherPrivacy",
      component: XbTeacherPrivacy,
      meta: {
        title: "隐私政策",
      },
    },
    {
      path: "/xbproductprotocol",
      name: "XbProductProtocol",
      component: XbProductProtocol,
      meta: {
        title: "产品服务协议",
      },
    },
    {
      path: "/xbuseprotocol",
      name: "XbUseProtocol",
      component: XbUseProtocol,
      meta: {
        title: "软件使用协议",
      },
    },
    {
      path: "/xbcopyrightnotice",
      name: "XbCopyrightNotice",
      component: XbCopyrightNotice,
      meta: {
        title: "版权声明",
      },
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js